import React from "react";

import styled, { css } from "styled-components";

const StyledShelf = styled.div`
  ${({ mobile }) =>
    mobile &&
    css`
      @media screen and (max-width: 480px) {
        margin-bottom: ${mobile}px;
      }
    `}

  ${({ tablet }) =>
    tablet &&
    css`
      @media screen and (min-width: 481px) and (max-width: 1024px) {
        margin-bottom: ${tablet}px;
      }
    `}

  ${({ desktop }) =>
    desktop &&
    css`
      @media screen and (min-width: 1025px) {
        margin-bottom: ${desktop}px;
      }
    `}
`;

const Shelf = ({ children, ...props }) => (
  <StyledShelf {...props}>{children}</StyledShelf>
);

export default Shelf;
